/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  MISSION CORE PHILOSOPHY                                   ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Mission Control: Managing Full Lifecycle        ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const MISSION_CORE = `
# Mission Management Philosophy

Manage the entire mission lifecycle:
1. Track mission status throughout execution
2. Handle recovery from failures
3. Determine completion conditions
4. Ensure clean mission closure

A mission succeeds when all objectives are met.
`;
